import { store } from './store';
import { api } from './rtkClient';

export const logout = async (path) => {
    // Only remove auth-related keys so that project/task data is preserved
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
    sessionStorage.clear(); // Clear project context to prevent fluctuation for next user
    try {
        store.dispatch(api.util.resetApiState());
        store.dispatch({ type: 'auth/logout' });
    } catch (e) {
        console.error("Failed to clear store", e);
    }
    window.location.href = '/' + (path || '');
}
